// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FGI4hAEu_qMD0398yqDp{align-items:center;gap:10px;padding-top:8px;padding-bottom:12px;padding-left:20px;display:flex}.fjA23q6xyisoG65YJ1Nu{height:24px;font-size:16px;line-height:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `FGI4hAEu_qMD0398yqDp`,
	"searchInput": `fjA23q6xyisoG65YJ1Nu`
};
export default ___CSS_LOADER_EXPORT___;
